<template>
  <payment-in v-if="$i18n.locale == 'en'"/>
  <payment-ru v-else />

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "../api";
import _ from "underscore";
import PaymentIn from './PaymentIn'
import PaymentRu from './PaymentRu'

export default {
  name: "Payment",
  components: {
    PaymentIn,
    PaymentRu,
  },
  computed: _.extend(
    {},
    mapGetters({
      place: "getPlaceInfo",
      identityId: "getIdentityId"
    }),
    {}
  ),
  data() {
    return {
      showInfoBlock: false,
      isLoading: false
    };
  },
  methods: _.extend({}, mapActions(["populatePlaceInfo", "updatePlaceInfo"]), {
    openPaymentWindow: function() {
      // this.$buefy.dialog.alert({
      //     title: "Your card was not charged",
      //     type: 'is-success',
      //     message: "We are in the process of launching in your country. <br /><br />Until we are ready to accept your payment you can use the service for <b>free</b>. <br /><br /> We will notify you about upcoming payment one month in advance."

      //   })
      // window.removeEventListener("beforeunload", () => {})
      window.beforeunload = function () {}
      this.isLoading = true;
      this.$ma.trackEvent({category: 'event', action: 'Payment initiated: Uniteller', label : null, value : null})
      let body = {
        Customer_IDP: this.identityId,
        email: this.info.email
      };
      api.uniCreatePaymentLink(body).then(response => {
        // this.isLoading = false
        window.open(response.data, "_self");
      });
      api.sendNotification({message: 'Payment attempted: ' + this.info.url});
      this.$ma.trackEvent({category: 'event', action: 'Payment initiated: savemenu.app', label : null, value : null})
    },
  nextDate: function() {
    let today = new Date()
    let newDate = new Date(today.setDate(today.getDate() + 30));
    let dd = String(newDate.getDate()).padStart(2, '0');
    let mm = String(newDate.getMonth() + 1).padStart(2, '0');
    let yyyy = newDate.getFullYear();
    return mm + '/' + dd + '/' + yyyy;
  }
  }),
  mounted() {
    window.onbeforeunload = function () {}
    this.$title = this.$t('title') + " | " + this.$t('Payment.title')
    this.$ma.trackEvent({category: 'event', action: 'Page viewed: ' + this.$route.fullPath, label : null, value : null})
  }
};



</script>



<style scoped>
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}



.ElementsApp, .ElementsApp .InputElement {
  color: #32325d;font-family: "Helvetica Neue", Helvetica, sans-serif;font-size: 16px;-webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ElementsApp:not(.is-autofilled) .InputElement:-webkit-autofill {
  color: #32325d;
  -webkit-text-fill-color: #32325d;
}
.ElementsApp .InputElement + .InputContainer-placeholder--ie {
  opacity: 1;color: #aab7c4;
}
.ElementsApp .InputElement::-webkit-input-placeholder {
  opacity: 1;color: #aab7c4;
}
.ElementsApp .InputElement::-moz-placeholder {
  opacity: 1;color: #aab7c4;
}
.ElementsApp .InputElement:-ms-input-placeholder {
  opacity: 1;color: #aab7c4;
}
.ElementsApp .InputElement::placeholder {
  opacity: 1;color: #aab7c4;
}
.ElementsApp .InputElement.is-invalid {
  color: #fa755a;
}
.ElementsApp:not(.is-autofilled) .InputElement.is-invalid:-webkit-autofill {
  color: #fa755a;
  -webkit-text-fill-color: #fa755a;
}
.ElementsApp.is-invalid .Icon-fill {
  fill: #fa755a;
}

/* Pricing */

.payment-page {
  padding-top: 0.5rem;
}

.payment{
  width: 700px; 
  margin: 0 auto;
}

@media only screen and (max-width: 768px) {
 .pricing-table {
   width: 100%;
 } 

 .payment{
  width: 100%; 
}
}
</style>
